import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {ICustomSecurity, IModelSecurityEquivalent, ISecuritySecurityEquivalent} from "@irb/irb-editors/irb-editors.model";
import {ISecurityCustomCategories, ISecurityCustomCategory} from "@irb/irb-models/irb-models.model";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {AppService} from "@irb/app.service";
import {IEvent, IrbAppEvents, IrbSettingsEvents} from "@irb-common/events";
import {Subscription} from "rxjs";
import {SecurityEquivalentsGridLayoutService} from "@irb/irb-editors/editor-security/security-equivalents-alternatives/security-equivalents-grid-layout.service";
import {CalltoactionService} from "@irb-common/components/calltoaction/calltoaction.service";
import {IAlertDialogData} from "@irb/app.model";
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
    selector: 'irb-com-es-security-equivalents',
    templateUrl: './com-es-security-equivalents.component.html',
    styleUrls: ['./com-es-security-equivalents.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComEsSecurityEquivalentsComponent implements OnInit, OnDestroy {
    @ViewChild("equivalentSecuritiesDropdown") equivalentSecuritiesDropdown: any;
    @ViewChild("customCategoriesDropdown") customCategoriesDropdown: any;
    @ViewChild('singleSecurityEquivalentTooltip') singleSecurityEquivalentTooltip: ElementRef;
    @ViewChild('categoryEquivalentTooltip') categoryEquivalentTooltip: ElementRef;

    private eventSubscription: Subscription;
    equivalentSecurities: Array<ICustomSecurity> = [];
    equivalentSecuritiesDropdownData: Array<IDropdownItem> = [];
    equivalentCategories: Array<ISecurityCustomCategory> = [];
    customCategoriesDropdownData: Array<IDropdownItem> = [];
    selectedCustomCategory: Array<IDropdownItem>;
    selectedEquivalentSecurity: Array<IDropdownItem>;
    _gridOptions: any;
    grid: any;
    private _securityEquivalentsData: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] };
    private _securityAllocationEquivalentDTO: IModelSecurityEquivalent[] | ISecuritySecurityEquivalent[];
    _trackerObjectsDTO: (IModelSecurityEquivalent | ISecuritySecurityEquivalent)[];
    heldCount = 0;
    securityCount = 0;
    categoryCount = 0;
    singleEquivalentToolTipErrorMessage = "";
    categoryEquivalentToolTipErrorMessage = "";
    addNewCategoryItem: any = {
        button: 'Add new category',
        type: 'assetCategory',
        fromComp: 'ComEsSecurityEquivalentsComponent'
    };
    addNewSecurityItem: any = {
        button: 'Add new security',
        type: 'security',
        fromComp: 'ComEsSecurityEquivalentsComponent'
    };
    isUiTest = false;
    ENABLE_AS_SECTYPE: boolean;
    frameworkComponents: any;
    gridHeight: string;
    isCashType: boolean;


    @Input()
    set securityEquivalentsData(value: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] }) {
        this._securityEquivalentsData = value;
        this.selectedCustomCategory = null;
        this.selectedEquivalentSecurity = null;
        this.securityCount = 0;
        this.heldCount = 0;
        this.isCashType = (value?.securityData.length) ? value?.securityData[0].securityType === 'CASH' : false;
        this.loadData();
    }

    @Output()
    securityEquivalentsChanged: EventEmitter<Array<IModelSecurityEquivalent | ISecuritySecurityEquivalent>> = new EventEmitter<Array<IModelSecurityEquivalent | ISecuritySecurityEquivalent>>();


    constructor(private irbEditorsService: IrbEditorsService,
                private as: AppService,
                private utilService: UtilityService,
                private cdr: ChangeDetectorRef,
                private ctas: CalltoactionService,
                private gls: SecurityEquivalentsGridLayoutService) {
        this.ENABLE_AS_SECTYPE = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_AS_SECTYPE || false;

        
        this.frameworkComponents = this.gls.getFrameworkComponents();
    }

    isExternalFilterPresent() {
        return true;
    }

    doesExternalFilterPass(node: any) {
        return !node.data.isUIdeleted;
    }

    private loadData() {
        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(this),
            floatingFilter: false,
            overlayNoRowsTemplate:
                "<span class='ag-overlay-loadGriding-center ag-overlay-message'>No Security Equivalents Data</span>",
            context: {componentParent: this},
            isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
            doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
            suppressHorizontalScroll: true
        };
        this.getAllSecuritiesForAllEqvForDD();

        if (this._securityEquivalentsData.isModelSecurity) {
            this._securityAllocationEquivalentDTO = this._securityEquivalentsData.securityData[0].secEquivalentsDtoSet
            && this._securityEquivalentsData.securityData[0].secEquivalentsDtoSet ?
                JSON.parse(JSON.stringify(this._securityEquivalentsData.securityData[0].secEquivalentsDtoSet)) : [];
            this.setTrackerObjectDTOArray(this._securityAllocationEquivalentDTO);
            this.loadGrid();
        } else {
            this.irbEditorsService.getAllocationEquivalentSecs(this._securityEquivalentsData.securityData[0].securityId).subscribe(
                (securityEquivalentsDTOResponse: any) => {
                    this._securityAllocationEquivalentDTO = securityEquivalentsDTOResponse;
                    this.setTrackerObjectDTOArray(securityEquivalentsDTOResponse);
                    this.loadGrid();
                });
        }

    }

    ngOnInit(): void {
        this.eventSubscription = this.as.getEvents().subscribe((s) => {
            this.processEvent(s);
        });
        this.getCustomCategoriesForDD();
    }

    private getCustomCategoriesForDD() {
        this.irbEditorsService.getCustomCategories().subscribe((customCategoriesDropdownData: ISecurityCustomCategories) => {
            this.equivalentCategories = customCategoriesDropdownData.items;
            if (customCategoriesDropdownData.items && customCategoriesDropdownData.items.length > 0) {
                customCategoriesDropdownData.items = customCategoriesDropdownData.items.filter(x => x.custCatId !== 0);
            }
            this.customCategoriesDropdownData = [];
            customCategoriesDropdownData.items.forEach((item: ISecurityCustomCategory) => {
                this.customCategoriesDropdownData.push({
                    name: item.custCatName,
                    value: item.custCatId
                } as IDropdownItem);
            });

            this.utilService.sortByKey(this.customCategoriesDropdownData, "name", "asc");
            this.customCategoriesDropdownData = this.getDistinctCategories(this.customCategoriesDropdownData);

            this.customCategoriesDropdownData.unshift({
                value: 0,
                name: 'None'
            });
        });
    }

    private getAllSecuritiesForAllEqvForDD() {
        const getSecuritiesForEqv = this.isCashType
            ? (_: any) => this.irbEditorsService.getAllMmfSecuritiesForCashEqv()
            : (securityId: any) => this.irbEditorsService.getAllSecuritiesForAllEqv(securityId);
        getSecuritiesForEqv(this._securityEquivalentsData.securityData[0].securityId).subscribe((securityEquivalentsResponse: any) => {
            this.irbEditorsService.passSecuritiesForAllEqvSubject(securityEquivalentsResponse);
            this.equivalentSecurities = securityEquivalentsResponse.items as Array<ICustomSecurity>;

            if (this.equivalentSecurities && this.equivalentSecurities.length > 0) {
                this.equivalentSecuritiesDropdownData = [];
                this.equivalentSecurities.forEach((item: any) => {
                    this.equivalentSecuritiesDropdownData.push({
                        name: item.securitySymbol,
                        value: item.securityId
                    } as IDropdownItem);
                });

                this.utilService.sortByKey(this.equivalentSecuritiesDropdownData, "name", "asc");

                this.equivalentSecuritiesDropdownData.unshift({
                    value: 0,
                    name: "None"
                } as IDropdownItem);
            }
        });
    }

    private getDistinctCategories(categories: IDropdownItem []) {
        const distinctCategories: IDropdownItem [] = [];

        if (categories && categories.length > 0) {
            categories.forEach((x: IDropdownItem) => {
                if (x.name
                    && distinctCategories.findIndex(y => x.name === y.name) === -1) {
                    distinctCategories.push(x);
                }
            });
        }

        return distinctCategories;
    }

    showAddMultipleSecuritiesDialog() {
        let dataInputForMultipleSelection:any=[];
        this.grid.api.forEachNode(function(node:any){
            dataInputForMultipleSelection.push(node.data);
    
        });
        let newItem: IModelSecurityEquivalent | ISecuritySecurityEquivalent;
        let securityBeingEdited = this._securityEquivalentsData.securityData[0];

        newItem = {
            altIfHeldFlag: false,
            eqSecurityDescription: securityBeingEdited?.securityDescription,
            eqSecuritySymbol: securityBeingEdited?.securitySymbol,
            eqSecurityType: securityBeingEdited?.securityType,
            equivalentCategoryId: null,
            equivalentSecurityId: securityBeingEdited?.securityId,
            isNew: false,
            isUIdeleted: false,
            modelSecEquivalentId: null,
            securityEquivalentId: null,
            securityId: securityBeingEdited?.securityId
        };
        dataInputForMultipleSelection.push(newItem);
        let symbol = this._securityEquivalentsData.securityData[0].securitySymbol;
        const params = {
            type: this.isCashType ? 'editCashEquivalents' : 'editSecurity',
            dialogTitle: this.isCashType ? 'Add Multiple Cash Equivalents' : 'Add multiple equivalents to this security - ' + symbol,
            securitySymbol: this.isCashType ? null : symbol,
            data:dataInputForMultipleSelection,
            field: "equivalentSecurityId"

        };
        this.as.fireEvent(IrbModelsEvents.SHOW_MASTER_MULTIPLE_SECURITY, params);
    }

    private processEvent(event: IEvent) {
        switch (event.type) {
            case IrbModelsEvents.SAVE_MASTER_MULTIPLE_SECURITY:
                if (event.data && event.data.type === 'editSecurity' || event.data.type === 'editCashEquivalents') {
                    this.addSecuritiesFromMaster(event.data);
                }
                break;
            case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
                if (event.data) {
                    if (event.data.editSecurity === true) {
                        this.addNewlyCreatedSecurity(event);
                    }
                    if (event.data.type === 'security' && event.data.fromComp === 'ComEsSecurityEquivalentsComponent') {
                        this.resetSecuritySearch(event.data)
                    }
                }

                break;
            case IrbSettingsEvents.ASSET_CATEGORY_UPDATED:
                if (event.data) {
                    if (event.data.type === 'assetCategory' && event.data.fromComp === 'ComEsSecurityEquivalentsComponent') {
                        this.resetCategorySearch(event.data)
                    }
                }
                break;
        }
    }

    private addSecuritiesFromMaster(eventData: any) {
        // console.log('Data from Security Master', eventData);
        const alreadyAddedSymbols: string[] = [];
        let hasEditSecurity = false;
        let hasCashSecurity = false;
        if (!this._trackerObjectsDTO) {
            this._trackerObjectsDTO = [];
        }
        if (eventData.selectedSecurities && eventData.selectedSecurities.length !== 0) {
            eventData.selectedSecurities.forEach((newSecurity: any) => {
                if (newSecurity.securityId === this._securityEquivalentsData.securityData[0].securityId) {
                    hasEditSecurity = true;
                } else if (newSecurity.securitySymbol === '$CASH') {
                    hasCashSecurity = true;
                } else {
                    const equivalentPresent = this._trackerObjectsDTO.find(x => x.equivalentSecurityId === newSecurity.securityId);

                    if (equivalentPresent && equivalentPresent.equivalentSecurityId > 0) {
                        // equivalent present . Now check if it is UIDeleted then set that to UIDeleted to false.
                        if (equivalentPresent.isUIdeleted) {
                            equivalentPresent.isUIdeleted = false;
                        } else {
                            // its not UIDeleted - so no need to add it.
                            // Add error already added.
                            alreadyAddedSymbols.push(equivalentPresent.eqSecuritySymbol);
                        }
                    } else {
                        // security is not present. so Just add it with isNew Flag to true.
                        let newItem: IModelSecurityEquivalent | ISecuritySecurityEquivalent;
                        if (this._securityEquivalentsData.isModelSecurity) {

                            newItem = {
                                altIfHeldFlag: false,
                                eqSecurityDescription: newSecurity.securityDescription,
                                eqSecuritySymbol: newSecurity.securitySymbol,
                                eqSecurityType: newSecurity.securityType,
                                equivalentCategoryId: null,
                                equivalentSecurityId: newSecurity.securityId,
                                isNew: true,
                                isUIdeleted: false,
                                modelSecEquivalentId: null,
                                securityEquivalentId: null,
                                securityId: this._securityEquivalentsData.securityData[0].securityId,
                                securityModelAllocationId: null
                            };
                        } else {

                            newItem = {
                                altIfHeldFlag: false,
                                eqSecurityDescription: newSecurity.securityDescription,
                                eqSecuritySymbol: newSecurity.securitySymbol,
                                eqSecurityType: newSecurity.securityType,
                                equivalentCategoryId: null,
                                equivalentSecurityId: newSecurity.securityId,
                                isNew: true,
                                isUIdeleted: false,
                                securityEquivalentId: null,
                                securityId: this._securityEquivalentsData.securityData[0].securityId,
                            };
                        }
                        this.addToTrackerObject(newItem);
                    }
                }
            });

            if (hasEditSecurity || hasCashSecurity || (alreadyAddedSymbols && alreadyAddedSymbols.length > 0)) {
                // Fire cannot add the parent security!
                // this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                //     msg: `Security "${this._securityEquivalentsData.securityData[0].securitySymbol}"` + " cannot be used as its own equivalent.",
                //     dTitle: "Error",
                //     dType: "ERROR",
                //     onProceed: () => {
                //     }
                // } as IAlertDialogData);
                let alreadyAddedSymbolsMessage = "";
                let toastMessage = "";
                if (alreadyAddedSymbols && alreadyAddedSymbols.length > 0) {
                    if (alreadyAddedSymbols.length === 1) {
                        alreadyAddedSymbolsMessage = `"${alreadyAddedSymbols.join(',')}"  is already an equivalent to this security. Securities cannot be listed as equivalents twice.`
                    } else {
                        alreadyAddedSymbolsMessage = `Securities cannot be listed as equivalents twice.`
                    }
                }
                if (hasEditSecurity) {
                    toastMessage = `Security "${this._securityEquivalentsData.securityData[0].securitySymbol}"` + " cannot be used as its own equivalent. " + alreadyAddedSymbolsMessage;
                } else if(alreadyAddedSymbols && alreadyAddedSymbols.length >0) {
                    toastMessage = alreadyAddedSymbolsMessage;
                } else if(hasCashSecurity) {
                    toastMessage ="$CASH cannot be listed as an equivalent."
                }
                this.showAddMultipleSecuritiesToast('error', 'Alert', toastMessage, '');
            }
            this.loadGrid();
            let equivalentsDTO = JSON.parse(JSON.stringify(this._trackerObjectsDTO));
            this.securityEquivalentsChanged.emit(equivalentsDTO);
        }
    }

    showAddMultipleSecuritiesToast(severity: any, summary: string, detail: string, linkText: string) {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            key: 'irb-embedded-link-toast',
            severity: severity,
            summary: summary,
            detail: detail,
            sticky: false,
            closable: true,
            linkText: linkText,
            callBack: (() => {
                this.as.fireEvent(IrbAppEvents.HIDE_TOAST);
            })
        });
    }

    ngOnDestroy(): void {
        if (this.eventSubscription) {
            this.eventSubscription.unsubscribe();
        }
    }

    private setTrackerObjectDTOArray(equivalentsDTOArray: any[]) {
        if (equivalentsDTOArray) {
            this._trackerObjectsDTO = JSON.parse(JSON.stringify(equivalentsDTOArray));
        }
    }

    public delete(cc: any) {
        let itemIndex = this._trackerObjectsDTO.findIndex(x => x.equivalentSecurityId === cc.equivalentSecurityId);
        if (this._trackerObjectsDTO[itemIndex].isNew) {
            this._trackerObjectsDTO.splice(itemIndex, 1);
        } else {
            this._trackerObjectsDTO[itemIndex].isUIdeleted = true;
        }
        this.loadGrid();
        let equivalentsDTO = JSON.parse(JSON.stringify(this._trackerObjectsDTO));
        this.securityEquivalentsChanged.emit(equivalentsDTO);
    }

    public deleteAll() {
        for (let i = 0; i < this._trackerObjectsDTO.length; i++) {
            this._trackerObjectsDTO[i].isUIdeleted = true;
        }
        this._trackerObjectsDTO = this._trackerObjectsDTO.filter(x => !x.isNew);
        this.loadGrid();

        let equivalentsDTO = JSON.parse(JSON.stringify(this._trackerObjectsDTO));
        this.securityEquivalentsChanged.emit(equivalentsDTO);
    }

    public cancelDelete() {
        this.ctas.remove();
    }

    set gridOptions(gridOpns: any) {
        this._gridOptions = gridOpns;
    }

    get gridOptions() {
        return this._gridOptions;
    }

    onGridReady(params: any) {
        this.grid = params;
        this.loadGrid();
    }

    private loadGrid() {
        if (this.grid && this.grid.api && this._trackerObjectsDTO) {
            this.grid.api.setGridOption('rowData', this._trackerObjectsDTO);
            let countsObj = this.getEquivalentSecurityHeldCounts();
            this.heldCount = countsObj.heldCount;
            this.securityCount = countsObj.securityCount;
            this.categoryCount = countsObj.categoryCount;
            this.updateGridHeight();
        }
    }

    getRowCount() {
        return (this._trackerObjectsDTO) ? this._trackerObjectsDTO.length : 0;
    }

    onAddSymbolEquivalent() {
        const alreadyAddedSymbols: string[] = [];
        let hasEditSecurity = false;
        if (!this._trackerObjectsDTO) {
            this._trackerObjectsDTO = [];
        }
        if (this.selectedEquivalentSecurity && this.selectedEquivalentSecurity.length !== 0) {
           this.selectedEquivalentSecurity.forEach((newSecurity: IDropdownItem) => {
               if (newSecurity.value > 0) {
                   if (newSecurity.value === this._securityEquivalentsData.securityData[0].securityId) {
                       hasEditSecurity = true;
                   } else {
                       const equivalentPresent = this._trackerObjectsDTO.find(x => x.equivalentSecurityId === newSecurity.value);
                       if (equivalentPresent && equivalentPresent.equivalentSecurityId > 0) {
                           // equivalent present . Now check if it is UIDeleted and if so, set uiDeleted to false
                           if (equivalentPresent.isUIdeleted) {
                               equivalentPresent.isUIdeleted = false;
                           } else {
                               // its not UIDeleted - so no need to add it.
                               // Add error already added.
                               alreadyAddedSymbols.push(equivalentPresent.eqSecuritySymbol);
                           }
                       } else {
                           // security is not present. so add it with isNew Flag to true.
                           let newItem: IModelSecurityEquivalent | ISecuritySecurityEquivalent;
                           const s = this.getEquivalentSecurity(newSecurity.value);
                           if (this._securityEquivalentsData.isModelSecurity) {
                               newItem = {
                                   altIfHeldFlag: false,
                                   eqSecurityDescription: s.securityDescription,
                                   eqSecuritySymbol: newSecurity.name,
                                   eqSecurityType: s.securityType,
                                   equivalentCategoryId: null,
                                   equivalentSecurityId: newSecurity.value,
                                   isNew: true,
                                   isUIdeleted: false,
                                   modelSecEquivalentId: null,
                                   securityEquivalentId: null,
                                   securityId: this._securityEquivalentsData.securityData[0].securityId,
                                   securityModelAllocationId: null
                               };
                           } else {

                               newItem = {
                                   altIfHeldFlag: false,
                                   eqSecurityDescription: s.securityDescription,
                                   eqSecuritySymbol: newSecurity.name,
                                   eqSecurityType: s.securityType,
                                   equivalentCategoryId: null,
                                   equivalentSecurityId: newSecurity.value,
                                   isNew: true,
                                   isUIdeleted: false,
                                   securityEquivalentId: null,
                                   securityId: this._securityEquivalentsData.securityData[0].securityId,
                               };
                           }
                           this.addToTrackerObject(newItem);
                       }
                   }
               }

           });
           if (hasEditSecurity || (alreadyAddedSymbols && alreadyAddedSymbols.length > 0)) {
               let alreadyAddedSymbolsMessage = "";
               let toastMessage = "";
               if (alreadyAddedSymbols && alreadyAddedSymbols.length > 0) {
                   if (alreadyAddedSymbols.length === 1) {
                       alreadyAddedSymbolsMessage = `"${alreadyAddedSymbols.join(',')}"  is already an equivalent to this security. Securities cannot be listed as equivalents twice.`
                   } else {
                       alreadyAddedSymbolsMessage = `Securities cannot be listed as equivalents twice.`
                   }
               }
               if (hasEditSecurity) {
                   toastMessage = `Security "${this._securityEquivalentsData.securityData[0].securitySymbol}"` + " cannot be used as its own equivalent. " + alreadyAddedSymbolsMessage;
               } else if(alreadyAddedSymbols && alreadyAddedSymbols.length >0) {
                   toastMessage = alreadyAddedSymbolsMessage;
               }
               this.showAddMultipleSecuritiesToast('error', 'Alert', toastMessage, '');
           }
        }
        this.loadGrid();
        let equivalentsDTO = JSON.parse(JSON.stringify(this._trackerObjectsDTO));
        this.securityEquivalentsChanged.emit(equivalentsDTO);
        this.equivalentSecuritiesDropdown.clear();
    }

    onSingleEquivalentChanged(selections: Array<IDropdownItem>) {
        this.selectedEquivalentSecurity = selections;
        this.singleEquivalentToolTipErrorMessage = "";
    }

    onCategoryChanged(selections: Array<IDropdownItem>) {
        this.selectedCustomCategory = selections;
        this.categoryEquivalentToolTipErrorMessage = "";
    }

    onAddCategoryEquivalent() {
        let newItem: IModelSecurityEquivalent | ISecuritySecurityEquivalent;
        if (!this._trackerObjectsDTO) {
            this._trackerObjectsDTO = [];
        }
        const alreadyAddedCategories: string[] = [];
        if (this.selectedCustomCategory && this.selectedCustomCategory.length !== 0) {
            this.selectedCustomCategory.forEach((newCategory) => {
                if (newCategory.value > 0) {
                    const equivalentPresent = this._trackerObjectsDTO.find(x => x.equivalentSecurityId === newCategory.value);

                    if (equivalentPresent && equivalentPresent.equivalentSecurityId > 0) {
                        // equivalent present . Now check if it is UIDeleted then set that to UIDeleted to false.
                        if (equivalentPresent.isUIdeleted) {
                            equivalentPresent.isUIdeleted = false;
                        } else {
                            alreadyAddedCategories.push(equivalentPresent.eqSecuritySymbol);
                        }
                    } else {
                        // security is not present. so add it with isNew Flag to true.
                        const c = this.getEquivalentCategory(newCategory.value);
                        if (this._securityEquivalentsData.isModelSecurity) {
                            newItem = {
                                altIfHeldFlag: false,
                                eqSecurityDescription: c.custCatDesc,
                                eqSecuritySymbol: newCategory.name,
                                eqSecurityType: "CustCat",
                                equivalentCategoryId: null,
                                equivalentSecurityId: newCategory.value,
                                isNew: true,
                                isUIdeleted: false,
                                modelSecEquivalentId: null,
                                securityEquivalentId: null,
                                securityId: this._securityEquivalentsData.securityData[0].securityId,
                                securityModelAllocationId: null
                            };
                        } else {
                            newItem = {
                                altIfHeldFlag: false,
                                eqSecurityDescription: c.custCatDesc,
                                eqSecuritySymbol: newCategory.name,
                                eqSecurityType: "CustCat",
                                equivalentCategoryId: null,
                                equivalentSecurityId: newCategory.value,
                                isNew: true,
                                isUIdeleted: false,
                                securityEquivalentId: null,
                                securityId: this._securityEquivalentsData.securityData[0].securityId
                            };
                        }

                        this.addToTrackerObject(newItem);
                    }
                }
            });
            if (alreadyAddedCategories && alreadyAddedCategories.length > 0) {
                let toastMessage = "";
                if (alreadyAddedCategories.length === 1) {
                    toastMessage = `"${alreadyAddedCategories.join(',')}"  is already an equivalent to this security. Categories cannot be listed as equivalents twice.`;
                } else {
                    toastMessage = `Categories cannot be listed as equivalents twice.`
                }
                this.showAddMultipleSecuritiesToast('error', 'Alert', toastMessage, '');
            }
        }


        this.loadGrid();
        const equivalentsDTO = JSON.parse(JSON.stringify(this._trackerObjectsDTO));
        this.securityEquivalentsChanged.emit(equivalentsDTO);
        this.customCategoriesDropdown.clear();
    }

    private addToTrackerObject(newItem: IModelSecurityEquivalent | ISecuritySecurityEquivalent) {
        if (!this._trackerObjectsDTO) {
            this._trackerObjectsDTO = [];
        }

        this._trackerObjectsDTO.push(newItem);
    }

    onAltIfHeldCheckboxChanged(params: any, event: any, rowIndex?: any) {
        let equivalentPresent = this._trackerObjectsDTO.find(x => x.equivalentSecurityId === params.equivalentSecurityId);
        equivalentPresent.altIfHeldFlag = event;
        if (rowIndex !== null && typeof rowIndex !== 'undefined') {
            const n = this.grid.api.getDisplayedRowAtIndex(rowIndex);
            this.grid.api.redrawRows({ rowNodes: [n] });
            let countsObj = this.getEquivalentSecurityHeldCounts();
            this.heldCount = countsObj.heldCount;
            this.securityCount = countsObj.securityCount;
            this.categoryCount = countsObj.categoryCount;
        } else {
            this.loadGrid();
        }
        let equivalentsDTO = JSON.parse(JSON.stringify(this._trackerObjectsDTO));
        this.securityEquivalentsChanged.emit(equivalentsDTO);
    }

    getEquivalentSecurityHeldCounts() {
        let heldCount = 0;
        let securityCount = 0;
        let categoryCount = 0;
        if (this._trackerObjectsDTO && this._trackerObjectsDTO.length > 0) {
            heldCount = this._trackerObjectsDTO.filter(x => !x.isUIdeleted && x.altIfHeldFlag).length;
            securityCount = this._trackerObjectsDTO.filter(x => !x.isUIdeleted && x.eqSecurityType !=='CustCat' && !x.altIfHeldFlag).length;
            categoryCount = this._trackerObjectsDTO.filter(x => !x.isUIdeleted && x.eqSecurityType ==='CustCat').length;
        }
        return {heldCount: heldCount, securityCount: securityCount, categoryCount: categoryCount};
    }

    getEquivalentsText() {
        let equivalentText = '';
        if (this.securityCount === 1) {
            equivalentText = '1 equivalent security; '
        } else {
            equivalentText = this.securityCount + ' equivalent securities; '
        }
        equivalentText = equivalentText + this.heldCount + ' alt if held; '
        if(this.categoryCount === 1) {
            equivalentText = equivalentText + '1 equivalent category'
        } else {
            equivalentText = equivalentText + this.categoryCount + ' equivalent categories'
        }
        return equivalentText;
    }
    onCreateNewSecurity() {
        const dataParam: any = {
            editSecurity: true,
            editSecurityTaxAlternateSingleEquivalentSymbol: true
        };
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }

    addNewlyCreatedSecurity(event: IEvent) {
        let newData = event.data;
        const getSecuritiesForEqv = this.isCashType
            ? (_: any) => this.irbEditorsService.getAllMmfSecuritiesForCashEqv()
            : (securityId: any) => this.irbEditorsService.getAllSecuritiesForAllEqv(securityId);
        getSecuritiesForEqv(this._securityEquivalentsData.securityData[0].securityId).subscribe(
            (securityEquivalentsResponse: any) => {
                this.equivalentSecuritiesDropdownData = securityEquivalentsResponse.items;
                if (this.equivalentSecuritiesDropdownData && this.equivalentSecuritiesDropdownData.length > 0) {
                    this.equivalentSecuritiesDropdownData = this.utilService.sortByKey(this.equivalentSecuritiesDropdownData, "name", "asc");
                    this.equivalentSecuritiesDropdownData.unshift({
                        value: 0,
                        name: "None"
                    } as IDropdownItem);
                }
            });
    }

    getItemsForEquivalentSecuritiesDropdown(searchString: string) {
        this.equivalentSecuritiesDropdown.set(DropdownFilterComponent.getFilteredList(searchString,this.equivalentSecuritiesDropdownData));
    }

    getItemsForCustomCategoriesDropdown(searchString: string) {
        this.customCategoriesDropdown.set(DropdownFilterComponent.getFilteredList(searchString,this.customCategoriesDropdownData));
    }

    getEquivalentSecurity(id: number): ICustomSecurity {
        return this.equivalentSecurities.find((x: ICustomSecurity) => x.securityId === id);
    }

    getEquivalentCategory(id: number): ISecurityCustomCategory {
        return this.equivalentCategories.find((x: ISecurityCustomCategory) => x.custCatId === id);
    }

    resetCategorySearch(dataParam: any) {
        if (dataParam && dataParam.newItems && dataParam.newItems.length !== 0) {
            this.customCategoriesDropdownData = this.customCategoriesDropdownData.concat(dataParam.newItems);
            this.equivalentCategories = this.equivalentCategories.concat(dataParam.newItems);

            if (dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
                if (this.customCategoriesDropdown && this.customCategoriesDropdown.setValue)
                this.customCategoriesDropdown.setValue(dataParam.newItemsForDD);
            }
            this.getCustomCategoriesForDD();
        }

    }

    resetSecuritySearch(dataParam: any) {
        if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
            this.equivalentSecuritiesDropdownData = this.equivalentSecuritiesDropdownData.concat(dataParam.newItems);
            if (dataParam.securities && dataParam.securities.responseData) {
                if (dataParam.securities.responseData.length !== 0) {
                    this.equivalentSecurities = this.equivalentSecurities.concat(dataParam.securities.responseData);
                }
            }
            if (dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
                if (this.equivalentSecuritiesDropdown && this.equivalentSecuritiesDropdown.setValue)
                this.equivalentSecuritiesDropdown.setValue(dataParam.newItemsForDD);
            }
            this.getAllSecuritiesForAllEqvForDD();
        }

    }

    openNewItemCategoryFlow(dataParam: any) {
        dataParam = Object.assign({}, this.addNewCategoryItem, dataParam);
        this.as.setToLocal("LAST_TAB_INDEX", 0);
        this.as.fireEvent(IrbSettingsEvents.SHOW, dataParam);
    }

    openNewItemSecurityFlow(dataParam: any) {
        dataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
        dataParam.editSecurity = true;
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }

    updateGridHeight() {
        const tr = this.grid?.api.getDisplayedRowCount() || 0;
    
        if (tr === 0) {
            this.gridHeight = "100px";
            this.grid.api.setGridOption('domLayout', 'normal');
        } else if (tr > 6) {
            this.gridHeight = "280px";
            this.grid.api.setGridOption('domLayout', 'normal');
        } else {
            this.gridHeight = "100%";
            this.grid.api.setGridOption('domLayout', 'autoHeight');
        }
    }
}
